import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom"
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import html2pdf from "html2pdf.js"
import tyclImg from '../../img/tycl-hd.png'
import borderImg from '../../img/border.png'
import glgImg from '../../img/GLGlogo.png'
import threeZeroImg from '../../img/3zero.png'
import rasaiyaImg from '../../img/rasaiya.png'
import keerthanaImg from '../../img/keerthana.jpg'
import sivaImg from '../../img/siva.png'
import "./GenerateCertificate.scss";

const GenerateCertificate = ({ match: { params: { id } }, profileInfo }) => {
    const ref = React.createRef();
    const toPdf = () => {
        // var printContents = document.getElementById("pdfFile").innerHTML;
        // var originalContents = document.body.innerHTML;

        // document.body.innerHTML = printContents;

        // window.print();

        // document.body.innerHTML = originalContents;

        var element = document.getElementById('printme');
        var opt = {
            // filename: 'girls-lead-girls-course-completion-certificate.pdf',
            // image: { type: 'jpeg', quality: 1 },
            // html2canvas: { scale: 1 },
            // jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            filename: 'youth-virtual-creative-art-camp-certificate.pdf',
            margin: 0,
            image: { type: 'jpeg', quality: 1 },
            html2canvas: {
                dpi: 192,
                scale: 2,
                letterRendering: true,
                useCORS: true
            },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        // New Promise-based usage:
        html2pdf().from(element).set(opt).save();

        // Old monolithic-style usage:
        // html2pdf(element, opt);
    }
    const size = "large"
    return (
        <div>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <p style={{ fontWeight: "bold", fontSize: "20px", color: "#61ce33" }}>Congratulations! <span style={{ color: "purple", display: "inline-block", textTransform: "uppercase" }}><span style={{ textTransform: "none" }}>{profileInfo && profileInfo.is_lgbtq && profileInfo.is_lgbtq != "0" ? "Mx" : "Ms"}</span>. {profileInfo && profileInfo.name}</span> for the successful completion of the Virtual Creative Art Camp programme. We wish you all the best for your future endeavours. </p>
                <Button type="primary" onClick={toPdf} icon={<DownloadOutlined />} size={size}>
                    Download Certificate
                </Button>
            </div>
            <div ref={ref} id="pdfFile" style={{ position: "relative", overflow: "scroll", marginTop: 20 }}>
                <div id="printme" style={{
                    margin: "24px auto 0 auto ",
                    width: "704px",
                    height: "1030px",
                    position: "relative"
                }} className="print-view">
                    <div style={{ position: 'absolute', zIndex: 0, marginLeft: '-5px' }}>
                        <img src={borderImg} width="704px" />
                    </div>
                    <div style={{ position: "relative", zIndex: 1 }}>
                        <div className="images" style={{ padding: '60px 30px', paddingBottom: 0, textAlign: 'center' }}>
                            <span id="tycl" style={{ padding: '0 20px' }}><img src={tyclImg} width="150px" /></span>
                        </div>
                        <div className="names" style={{ width: '100%', textAlign: 'center' }}>
                            <div className="n2">
                                <p style={{ fontSize: 25, margin: '25px 0 20px 0', color: '#d8b181' }}><b>TRUST FOR YOUTH AND CHILD LEADERSHIP (TYCL)</b></p>
                                <p style={{ fontSize: 16, color: '#936139', padding: '0px 0', margin: 0, fontWeight: 'bold' }}>PRODULY PRESENTS</p>
                                <p style={{ fontSize: 45, color: '#c99d67', fontWeight: 'bold', margin: '10px 0 10px 0' }}>Youth Creative Art Camp</p>
                                <p style={{ fontSize: 18, fontWeight: 'bold', color: '#9b6639' }}>"A virtual camp for youth to build postive mental health"</p>
                                </div>
                            <div>
                                <p style={{ color: 'purple', fontSize: 35, textAlign: 'center', margin: '0', textDecoration: 'underline', textUnderlinePosition: 'under', fontWeight: 'bold' }}>CERTIFICATE OF PARTICIPATION</p>
                            </div>
                        </div>
                        <div className="mainContent">
                            <p style={{ fontSize: 24, padding: "30px 46px 0px 39px", marginBottom: "33px", lineHeight: '1.6', textAlign: 'justify' }}>This is to certify that <span style={{ borderBottom: '2px solid rgb(201 157 103)', padding: '0 7px', color: 'rgb(201 157 103)', textTransform: 'uppercase', fontWeight: 'bold' }}>&nbsp;{profileInfo && profileInfo.name}&nbsp;</span> has successfully completed the e-learning programme on <b style={{ color: '#535051' }}>"<a href="https://www.tyclinternational.org/art-camp" style={{ color: "rgb(201 157 103)", borderBottom: '2px solid rgb(201 157 103)' }}>Youth Creative Art Camp</a> - for postive mental health"</b> developed by <a href="https://www.tyclinternational.in" style={{ color: '#2bace3', fontWeight: 'bold' }}>Trust for Youth and Child Leadership (TYCL)</a>. We wish all the very best for your future endeavours.</p>
                            
                        </div>
                        <div className="foot" style={{ fontSize: 18, paddingTop: 0, paddingBottom: 49, width: "100%", float: "left", margin: '0 auto' }}>
                            
                            <span className="guestSign" style={{  width: "200px", margin: " 0 4% ", float: "left", padding: "0", display:"block" }}>
                                <img style={{ padding: "18px 0 0 0", marginBottom: "3px" }} src={sivaImg} width="110px" />
                                <p style={{ borderTop: '1px solid #673a09', fontSize: "15px" }}><b>Dr.Siva Mathiyazhagan,</b><br /> Executive Director, <br /> TYCL International</p></span>
                                <span style={{ float: "right", padding: "120px 37px 20px 0px", fontSize: "16px" }} >Date of issue: <span style={{ fontWeight: "bold", color: "#535051" }}>{profileInfo && profileInfo.completion_date ? profileInfo.completion_date : ""}</span></span>
                        </div>

                    </div>
                   
                </div>
            </div>
        </div>
    )
}
export default withRouter(GenerateCertificate) 